export default __webpack_public_path__ + "static/media/Energy_Plug_White.6db2ed11.svg";